import React, {} from 'react';
import OutOfNetworkContainer from '../OutOfNetwork';
import { PlanService, SelectedNetwork } from '../../utils/types';

type Props = {
    show: boolean;
    service: PlanService | undefined;
    network: SelectedNetwork | undefined;
    handleStartOver: () => void;
}

const NoMatch = ({ show, service, network, handleStartOver }:Props): JSX.Element => {
    if (!show) {
        return (<></>);
    }
    return (
        <div style={{ marginTop: '30px' }}>
            <OutOfNetworkContainer service={service} network={network} handleStartOver={handleStartOver}/>
        </div>
    );
};

export default NoMatch;
